// Browser admission is UX; Platform independently enforces the same byte ceiling.
export const PACKING_UPLOAD_MAX_BYTES = 200_000_000;
export const PACKING_MEDIA_LIMIT = 5;
export const PACKING_UPLOAD_STALL_MS = 120_000;
